import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useSearchParams } from 'react-router-dom';

import { LightMode } from '@chakra-ui/react';

import { useAccessList } from '@tcap/data-router/hooks/useAccessList';

import { LoadingScreen } from '@/lib/loading-screen';
import {
    clearStoredRedirectTo,
    getStoredRedirectTo,
} from 'pages/auth/new/sso/utils/msLogin';

// login page
export default function AuthRouteLayout() {
    const { loadAccessList, token, loggedIn, reLogin, showMFA } = useSelector(
        (state) => state.login,
    );
    const { getAccessList } = useAccessList();
    const [searchParams] = useSearchParams();
    // A Microsoft redirect sign-in (popup blocked) saves redirectTo first.
    let redirectTo =
        new URLSearchParams(searchParams).get('redirectTo') ||
        getStoredRedirectTo() ||
        import.meta.env.VITE_APP_DEFAULT_REDIRECT_URL;
    const isAuthenticated = token && loggedIn && !reLogin && !showMFA;

    useEffect(() => {
        if (isAuthenticated && !loadAccessList) {
            clearStoredRedirectTo();
        }
    }, [isAuthenticated, loadAccessList]);
    /**
     * After logging in, this flag kicks off the data fetching process
     * required for TCAP.
     */
    useEffect(() => {
        //load access list after a succesful login/ relogin.
        if (loadAccessList) {
            getAccessList();
        }
    }, [loadAccessList, getAccessList]);

    if (loadAccessList) {
        return <LoadingScreen />;
    }

    if (!token || !loggedIn || reLogin || showMFA) {
        window.sessionStorage.clear();
        return (
            <LightMode>
                <div
                    style={{
                        backgroundColor: 'white',
                        color: '#1A202C',
                        minHeight: '100vh',
                        '--chakra-colors-chakra-body-bg': 'white',
                        '--chakra-colors-chakra-body-text': '#1A202C',
                    }}>
                    <Outlet context={{ token, loadAccessList }} />
                </div>
            </LightMode>
        );
    }

    return <Navigate to={redirectTo} replace />;
}
